import { getEnvironmentConfig, getEnvVariable, getFeatureBranchPrefix } from '../configHelper.js';
const definition = {
    base: {
        domain: 'https://local-vibe-api.burda-forward.de',
        path: '/api',
        xymaticCredentials: {
            username: 'testusername',
            password: 'testpassword',
        },
        tests: {
            xymaticContentIdLockTesting: 'd87c8f29-e762-slow-me42-please54510c',
        },
    },
    development: {
        domain: 'https://api.development-vibe.burda-forward.de',
        xymaticCredentials: {
            username: getEnvVariable('XYMATIC_USER'),
            password: getEnvVariable('XYMATIC_PASSWORD'),
        },
    },
    sandbox: {
        domain: getFeatureBranchPrefix()
            ? `https://${getFeatureBranchPrefix()}ctf-vibe.bf-ctf-sandbox.aws.bfops.io` // feature branch sandbox
            : 'https://api.sandbox-vibe.burda-forward.de', // main sandbox
        xymaticCredentials: {
            username: getEnvVariable('XYMATIC_USER'),
            password: getEnvVariable('XYMATIC_PASSWORD'),
        },
    },
    staging: {
        domain: 'https://api.staging-vibe.burda-forward.de',
        xymaticCredentials: {
            username: getEnvVariable('XYMATIC_USER'),
            password: getEnvVariable('XYMATIC_PASSWORD'),
        },
    },
    production: {
        domain: 'https://api.vibe.burda-forward.de',
        xymaticCredentials: {
            username: getEnvVariable('XYMATIC_USER'),
            password: getEnvVariable('XYMATIC_PASSWORD'),
        },
    },
};
export const apiServiceConfig = () => getEnvironmentConfig(definition);
//# sourceMappingURL=api.service.config.js.map